import { createNumberMask } from 'text-mask-addons'

export const ONE_NUMBER_MASK = [/\d/]
export const THREE_NUMBER_MASK = [/\d/, /\d/, /\d/]
export const THREE_NUMBER_MASK_WITHOUT_ZERO_AT_FIRST = [/[1-9]/, /\d/, /\d/]
export const DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
export const DATE_FOLHA_MASK = [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
export const CPF_MASK = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
export const CEP_MASK = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
export const CNPJ_MASK = [
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/
]

export const HOUR_MINUTE_MASK = [/\d/, /\d/, ':', /\d/, /\d/]

export const TELEFONE_MASK = inputValue => {
  const numbers = inputValue.match(/\d/g) || []
  const numberLength = numbers.join('').length

  if (inputValue.startsWith('0')) {
    return [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  }

  if (numberLength > 10) {
    return ['(', /[0-9]/, /[0-9]/, ')', ' ', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  }

  return ['(', /[0-9]/, /[0-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
}

export const UF_MASK = [/[A-Za-z]/, /[A-Za-z]/]

export const PERCENT_MASK = createNumberMask({
  prefix: '',
  allowDecimal: true,
  integerLimit: 2,
  decimalSymbol: ','
})

export const COEFICIENTE_MASK = createNumberMask({
  prefix: '',
  allowDecimal: true,
  thousandsSeparatorSymbol: '.',
  decimalLimit: 6,
  decimalSymbol: ','
})

export const COEFICIENTE_MASK_UNLIMITED = createNumberMask({
  prefix: '',
  includeThousandsSeparator: false,
  allowDecimal: true,
  decimalLimit: 99999,
  decimalSymbol: ','
})

export const NUMBER_MASK = createNumberMask({
  prefix: '',
  includeThousandsSeparator: false,
  allowDecimal: false,
  integerLimit: 99999
})

export const cpfPartialMask = cpf => {
  if (cpf) {
    const reg = /\d/g
    const hiddenChar = cpf.slice(0, 3) + cpf.slice(3, 9).replace(reg, '*') + cpf.slice(9, 12)
    return hiddenChar
  }
  return
}

export const cpfCompleteMask = cpf => {
  if (cpf) {
    const reg = /\d/g
    const hiddenChar = cpf.slice(0, 12).replace(reg, '*')
    return hiddenChar
  }
  return
}

export function formatCNPJ(cnpj) {
  if (!cnpj) return ''

  const digits = cnpj.replace(/\D/g, '')
  let index = 0

  return CNPJ_MASK.map(mask => {
    if (mask instanceof RegExp) {
      return digits[index++] || '_'
    }
    return mask
  }).join('')
}

export function formatCPF(cpf) {
  const isHidden = cpf.includes('*')

  if (isHidden) return cpf

  const filteredCpf = cpf.replace(/\D/g, '')

  if (filteredCpf.length !== 11) {
    return filteredCpf
  }

  return filteredCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}
